import React, { useEffect, useState } from "react";
import { getLocalStorageItemHandler } from "../../service/local-storage";
import { LOCALSTORAGE_KEYS, CLOUDINARY_BASE_URL } from "../../utils/enum";
import { GTM_ENUM } from "../../utils/gtm_enum";
import classes from "./header.module.scss";

const { getintouchBtnHeaderAPIex } = GTM_ENUM;
const Header = (props) => {
  const { USER_DATA } = LOCALSTORAGE_KEYS;
  const [email, setEmail] = useState(null);

  useEffect(() => {
    const token = getLocalStorageItemHandler(USER_DATA);
    let emailEncrypt = btoa(token?.email);
    setEmail(emailEncrypt);
  }, []);

  return (
    <div className={classes.header_container}>
      <div className="d-flex align-items-center cursor-pointer">
        <img
          className={classes.header_logo}
          onClick={() => {
            window.location.href = process.env.REACT_APP_API_WEBSITE_URL;
          }}
          alt="trademo logo"
          src={`${CLOUDINARY_BASE_URL}/v1644470254/global/trademo_logo/logo_purple_img3zz.svg`}
        />
        <div className={classes.shipment_button}>API Explorer</div>
      </div>
      <button
        id={getintouchBtnHeaderAPIex}
        onClick={() => {
          window.location.href = !!props.apiData.btnLink
            ? props.apiData.btnLink
            : process.env.REACT_APP_API_WEBSITE_URL + `/get-in-touch?type=${props.apiData.api_name}&session=${email}`;
        }}
        className="btn btn-sm primary_fill_sm_button"
      >
        {!!props.apiData?.isStatic ? "Request Demo" : "Get in Touch"}
      </button>
    </div>
  );
};

export default Header;
